import React, { useRef, useState } from "react";

import "./IndividualCoefficientsTooltip.scss";

const IndividualCoefficientsTooltip = ({ content, variant = "info" }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [placement, setPlacement] = useState("top");
    const wrapperRef = useRef(null);
    const popupRef = useRef(null);

    function showHandler() {
        const triggerRect = wrapperRef.current?.getBoundingClientRect();
        const popupHeight = popupRef.current?.offsetHeight || 0;
        setPlacement(triggerRect && triggerRect.top < popupHeight + 12 ? "bottom" : "top");
        setIsVisible(true);
    }

    function hideHandler() {
        setIsVisible(false);
    }

    return (
        <span
            ref={wrapperRef}
            className={"ic-tooltip"}
            onMouseEnter={showHandler}
            onMouseLeave={hideHandler}
        >
            <span className={`ic-tooltip__trigger ic-tooltip__trigger--${variant}`}>
                {variant === "info" ? "?" : "!"}
            </span>
            <span
                ref={popupRef}
                role={"tooltip"}
                className={
                    "ic-tooltip__popup" +
                    ` ic-tooltip__popup--${placement}` +
                    (isVisible ? " ic-tooltip__popup--visible" : "")
                }
            >
                {content}
                <span className={"ic-tooltip__arrow"} />
            </span>
        </span>
    );
};

export default IndividualCoefficientsTooltip;